import React from 'react';
import { useOfferContext } from '../../../../context';
import { AgentAvatar } from '../../../../components/Agent/AgentAvatar';

export function AgentAvatarContainer() {
  const { agentIcon, isTop, agentImageLink } = useOfferContext();

  return <AgentAvatar promoted={isTop} icon={agentIcon} imageLink={agentImageLink} />;
}
